import API_GATEWAY from "@/services/config/main-axios";

const currenciesService = {
  getAllCryptoCurrency(filters) {
    return API_GATEWAY.get("pricing/cryptoCurrency/getAllCryptoCurrency", {
      params: filters
    });
  },

  getCryptoCurrency(cryptocurrencyId) {
    return API_GATEWAY.get(
      `pricing/cryptoCurrency/getCryptoCurrency/${cryptocurrencyId}`
    );
  },

  changeAvailability(model) {
    return API_GATEWAY.post(
      "pricing/cryptoCurrency/updateSupportedCurrency",
      model
    );
  },

  changeWalletSupport(model) {
    return API_GATEWAY.post(
      "pricing/cryptoCurrency/updateWalletSupportedCurrency",
      model
    );
  },

  updateCurrencyCommission(model) {
    return API_GATEWAY.post("pricing/cryptoCurrency/updateCommission", model);
  },

  updateCurrencyAmountRange(model) {
    return API_GATEWAY.post(
      "pricing/cryptoCurrency/updateCryptoCurrency",
      model
    );
  },

  changeDefaultCommission(model) {
    return API_GATEWAY.post("pricing/commission/addDefaultCommission", model);
  }
};

export default currenciesService;
